import { forwardCellFocus } from '@crossbeam/bitts';

import { onBeforeUnmount, onMounted } from 'vue';

export function useForwardCellFocus(eGridCell?: HTMLElement) {
  function onFocusin(event: FocusEvent) {
    if (!eGridCell || event.target !== eGridCell) return;
    forwardCellFocus(eGridCell);
  }

  onMounted(() => {
    eGridCell?.addEventListener('focusin', onFocusin);
  });

  onBeforeUnmount(() => {
    eGridCell?.removeEventListener('focusin', onFocusin);
  });
}
